import LinearProgress from "@mui/material/LinearProgress"

export function SyncBar(props: { show: boolean }) {
  return props.show ? (
    <LinearProgress variant="indeterminate" />
  ) : (
    <LinearProgress variant="determinate" value={0} sx={{ opacity: 0 }} />
  )
}
